/**
 * Quickshop Desktop Auto-Click
 * Add to cart if the user changes size in quickshop on desktop, without needing to click the add to cart button.
 *
 * pendingProductHash guards against stale item-ready events: if the user switches
 * cards before React finishes re-rendering, the event for the previous card is ignored.
 */
import { isDesktopDisplay } from '../mobile/check';
import { QUICKSHOP_ITEM_READY } from '../../events';
let pendingCtaEl = null;
let pendingProductHash;
export const initQuickshopDesktopAutoClick = () => {
    document.addEventListener('change', (e) => {
        if (!isDesktopDisplay())
            return;
        const target = e.target;
        const sizeInput = target.closest('[data-quickshop-item-trigger]');
        if (!sizeInput)
            return;
        const form = sizeInput.closest('[data-quickshop-add-product-form]');
        if (!form || !form.dataset.productHash)
            return;
        // Single-size desktop: add via CTA only (size radio stays checked, no auto-click).
        if (form.querySelectorAll('[data-quickshop-item-trigger]').length <= 1)
            return;
        pendingProductHash = form.dataset.productHash;
        pendingCtaEl = form.querySelector('[data-product-cta]');
    });
    // React signals that the CTA is ready for the given product (EAN updated)
    document.addEventListener(QUICKSHOP_ITEM_READY, (e) => {
        if (!isDesktopDisplay() || !pendingCtaEl)
            return;
        // Ignore stale events: the user has already moved to another card
        if (e.detail.productHash !== pendingProductHash)
            return;
        const cta = pendingCtaEl;
        pendingCtaEl = null;
        pendingProductHash = undefined;
        const button = cta.querySelector('button[data-cart-add-product]:not([data-last-minute]):not(:disabled), button[data-role="customisation"]:not(:disabled)');
        if (button) {
            button.click();
        }
    });
};
